const menu = [
    {
        "id": 1,
        "pid": 0,
        "path": "",
        "name": "棚室列表",
        "icon": "icon-check-circle",
        "weigh": 0,
        "line": "",
        "isOpen": false,
        "isChecked": true,
    },
    {
        "id": 2,
        "pid": 0,
        "path": "device",
        "name": "设备列表",
        "icon": "icon-check-circle",
        "weigh": 0,
        "line": "",
        "isOpen": false,
        "isChecked": true,
    },
    {
        "id": 3,
        "pid": 0,
        "path": "video",
        "name": "视频监控",
        "icon": "icon-check-circle",
        "isOpen": false,
        "isChecked": true,
        "weigh": 0,

    },
    {
        "id": 4,
        "pid": 0,
        "path": "police",
        "name": "报警记录",
        "icon": "icon-check-circle",
        "isOpen": false,
        "isChecked": true,
        "weigh": 0,
  },
  // {
  //   "id": 5,
  //   "pid": 0,
  //   "path": "devicemanage",
  //   "name": "设备管理",
  //   "icon": "icon-check-circle",
  //   "isOpen": false,
  //   "isChecked": true,
  //   "weigh": 0,
  // }
]

const topnav = [

]
export { menu, topnav }